export default __webpack_public_path__ + "static/media/Roboto-Thin.1711b41f.ttf";